import _defineProperty from "@babel/runtime/helpers/defineProperty";
import cc from 'classcat';
import PropTypes from 'prop-types';
import { FIT_RATINGS, SIZE_NAME_MAP } from '../../config/constants-sizes';
import css from './Stats.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var getStatsInfo = function getStatsInfo(_ref) {
  var fitRating = _ref.fitRating,
      heightFeet = _ref.heightFeet,
      sizePurchased = _ref.sizePurchased,
      usualSizePurchased = _ref.usualSizePurchased;
  var hasStats = (heightFeet || sizePurchased || FIT_RATINGS[fitRating] || usualSizePurchased) && sizePurchased !== 'OS';
  return {
    hasStats: !!hasStats
  };
};

var Stats = function Stats(_ref2) {
  var autoHeight = _ref2.autoHeight,
      fitRating = _ref2.fitRating,
      heightFeet = _ref2.heightFeet,
      heightInches = _ref2.heightInches,
      name = _ref2.name,
      sizePurchased = _ref2.sizePurchased,
      usualSizePurchased = _ref2.usualSizePurchased;

  var _getStatsInfo = getStatsInfo({
    fitRating: fitRating,
    heightFeet: heightFeet,
    sizePurchased: sizePurchased,
    usualSizePurchased: usualSizePurchased
  }),
      hasStats = _getStatsInfo.hasStats;

  if (!hasStats) {
    return /*#__PURE__*/_jsx("div", {
      className: cc([css.root, _defineProperty({}, css.autoHeight, autoHeight)]),
      children: /*#__PURE__*/_jsx("div", {
        className: css.name,
        children: name
      })
    });
  }

  var stats = [];

  if (FIT_RATINGS[fitRating]) {
    stats.push({
      label: 'How it fits',
      value: FIT_RATINGS[fitRating]
    });
  }

  if (heightFeet) {
    stats.push({
      label: 'Height',
      value: "".concat(heightFeet, "&rsquo;").concat(heightInches ? "".concat(heightInches, "&rsquo;&rsquo;") : '')
    });
  }

  if (usualSizePurchased) {
    stats.push({
      label: 'Usual Size',
      value: SIZE_NAME_MAP[usualSizePurchased] || usualSizePurchased
    });
  }

  if (sizePurchased) {
    stats.push({
      label: 'Size purchased',
      value: SIZE_NAME_MAP[sizePurchased] || sizePurchased
    });
  }

  return /*#__PURE__*/_jsxs("div", {
    className: cc([css.root, _defineProperty({}, css.autoHeight, autoHeight)]),
    children: [/*#__PURE__*/_jsx("div", {
      className: css.name,
      children: name
    }), /*#__PURE__*/_jsx("ul", {
      className: css.list,
      children: stats.map(function (_ref5) {
        var label = _ref5.label,
            value = _ref5.value;
        return /*#__PURE__*/_jsxs("li", {
          className: css.item,
          children: [/*#__PURE__*/_jsxs("h5", {
            className: css.label,
            children: [label, ":"]
          }), /*#__PURE__*/_jsx("div", {
            className: css.value,
            dangerouslySetInnerHTML: {
              __html: value
            }
          })]
        }, label);
      })
    })]
  });
};

Stats.defaultProps = {
  autoHeight: false,
  fitRating: false,
  heightFeet: false,
  heightInches: false,
  modal: false,
  sizePurchased: false,
  usualSizePurchased: false
};
Stats.propTypes = {
  autoHeight: PropTypes.bool,
  fitRating: PropTypes.number,
  heightFeet: PropTypes.number,
  heightInches: PropTypes.number,
  modal: PropTypes.bool,
  name: PropTypes.string,
  sizePurchased: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  usualSizePurchased: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
};
export default Stats;